import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {segmentEventTracker} from "../../../utils/SegmentEventTracker";
import {TrackEventName} from "../../shared/constants/SegmentEvents";

const NewlyOnboardedCard  = ({isCallToAction, redirectTo=null, redirectToUrl="/"}) => {
  const header = isCallToAction === false ? "Thanks for submitting your information!" : 
    "Submit your invoices and purchase orders for pre-approval";
  const copy = isCallToAction === false ? "We will assess and verify them within 3 business days. Afterwards, you will find out what your initial credit limit is." :
    "In the meantime, you can start uploading unpaid invoices you issued, purchase orders you received, or similar documents to get pre-approved for a loan.";
  const onClick = () => {
    segmentEventTracker.trackEvent(TrackEventName.APPLY_FOR_A_LOAN_NOW_CLICKED);
    if(redirectTo !== null) redirectTo(redirectToUrl);
  }
  const bgClass = isCallToAction === false ? '-warning' : '';

  return (
    <section className={classNames('cardSection', '_textAlign_center', '_borderRadiusTop', bgClass)}  data-testid="newly-onboarded-home-card">
      <h2 className="headline -darkBlue _marginBottom--large" data-testid='newly-onboarded-home-title'>
        {header}
      </h2>
      <p className="byline -secondary --small" data-testid='newly-onboarded-home-copy'>{copy}</p>
      {isCallToAction &&
        <button
          data-testid='newly-onboarded-home-cta'
          data-path={redirectToUrl}
          className="ds-btn --micro -primary _displayBlock _margin--auto _marginTop--small _marginBottom--xsmall"
          onClick={onClick}>
          Apply for a loan now
        </button>}
    </section>
  );
}


NewlyOnboardedCard.propTypes = {
  redirectTo: PropTypes.func,
  isCallToAction: PropTypes.boolean,
  redirectToUrl: PropTypes.string
}

export default NewlyOnboardedCard;



// WEBPACK FOOTER //
// ./src/features/home/components/NewlyOnboardedCard.js